import { Button, Link, Para, Stack } from '@drycut/ui-components';
import { twJoin } from 'tailwind-merge';

type Props = {
  onAccept: () => void;
  onCancel: () => void;
  open?: boolean;
};

export function RulesAcceptance({ onAccept, onCancel }: Props): React.ReactElement {
  const linkClasses = twJoin(
    'underline text-white decoration-white decoration-1 font-semibold',
    'underline-offset-2 transition hover:text-slate-200 hover:decoration-slate-300',
  );

  return (
    <div className="flex grow w-full h-full">
      <div className="absolute inset-0 bg-white/80 z-40" />

      <div className="absolute z-50 w-full h-full inset-0 flex items-center justify-center">
        <Stack gap={4} className="text-white items-center bg-primary-600 p-5 w-3/4">
          <Para className="items-center">
            Mit der Reservierung stellt das System Dich zum gewählten Zeitpunkt in die Schlange (+/-
            10 Min). Wir garantieren{' '}
            <Para as="strong" weight="bold">
              nicht
            </Para>
            , dass Du{' '}
            <Para as="strong" weight="bold">
              genau
            </Para>{' '}
            zum gewählten Zeitpunkt dran kommst. Wenn der genaue Zeitpunkt wichtig ist, solltest Du
            auf die Vorausbuchung verzichten und Dich für den nächsten freien Termin anmelden (
            <Button
              onClick={onCancel}
              size="small"
              fill="ghost"
              textClassName="text-white group-hover:text-slate-200"
              className={twJoin(linkClasses, 'font-semibold inline-flex mx-0 p-0')}
            >
              Cut Now
            </Button>
            ).
          </Para>

          <Button
            size="small"
            onClick={onAccept}
            color="secondary"
            textClassName="text-slate-800"
            className={twJoin(
              'bg-white border-white px-8',
              'hover:bg-slate-200 hover:border-slate-200',
              'active:bg-slate-300 active:border-slate-300',
            )}
          >
            OK
          </Button>

          <Para>
            <Link href="https://www.drycut.ch/konzept" className={linkClasses}>
              Hier
            </Link>{' '}
            findest Du mehr Infos zur Reservierung.
          </Para>
        </Stack>
      </div>
    </div>
  );
}
